import React from "react";
import { useGlobalState } from "../../context/GlobalStateContext";
import "./LimitButton.scss";
import { useTranslation } from "react-i18next";

function LimitButton() {
  const { siteVersion } = useGlobalState();
  const { t: tCommon } = useTranslation(["common"]);

  return (
    <>
      {siteVersion === "client" && (
        <a
          href="https://paylateruz.onelink.me/iEhj/4uq59iuk"
          target="_blank"
          rel="noreferrer"
        >
          <button className="limit-button">
            {tCommon("anchors.mobileApp")}
          </button>
        </a>
      )}
    </>
  );
}

export default LimitButton;
